module.exports = __webpack_public_path__ + "img/comemoration.ab90682e.gif";